import { render } from "./conversation.vue?vue&type=template&id=68e3b9cb"
import script from "./conversation.js?vue&type=script&lang=js"
export * from "./conversation.js?vue&type=script&lang=js"

import "./conversation.vue?vue&type=style&index=0&id=68e3b9cb&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__